import React, { Suspense } from 'react';
import { RecoilRoot, MutableSnapshot } from 'recoil';

import {
	tokensState,
	approvalChallengeState,
	approvalVerifierState,
	approvalVerifierExpiredAtState,
	consentSessionIdState,
	persistState,
} from '../features/auth';
import { Main } from './Main';
import { LoadingScreen } from '../components/LoadingScreen';
// import classes from '*.module.css';

function initializeState({ set }: MutableSnapshot) {
	const tokensJSON =
		localStorage.getItem('tokens') || sessionStorage.getItem('tokens');
	if (tokensJSON) {
		try {
			const tokens = JSON.parse(tokensJSON);
			set(tokensState, tokens);
		} catch {}
	}
	const approvalChallenge = sessionStorage.getItem('approval_challenge');
	set(approvalChallengeState, approvalChallenge);
	const approvalVerifier = sessionStorage.getItem('approval_verifier');
	set(approvalVerifierState, approvalVerifier);

	const approvalVerifierExpiredAt = sessionStorage.getItem(
		'approval_verifier_expired_at'
	);
	set(approvalVerifierExpiredAtState, approvalVerifierExpiredAt);

	const consentSessionId = sessionStorage.getItem('consent_session_id');
	set(consentSessionIdState, consentSessionId);

	const persist = sessionStorage.getItem('persist');
	set(persistState, persist === 'true');
}

function App() {
	return (
		<RecoilRoot initializeState={initializeState}>
			<Suspense fallback={<LoadingScreen />}>
				<Main />
			</Suspense>
		</RecoilRoot>
	);
}

export default App;
